// extracted by mini-css-extract-plugin
module.exports = {"products":"WP-z","misad":"XP-z","oosMessaging":"YP-z","topProductFrame":"ZP-z","productCardOverrides":"_P-z","secondRowAds":"aQ-z","microsoftAdsWrapper":"bQ-z"};